import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell, ModalRef } from "@shared/components";
import { Agreement } from "@modules/agreements/types";

export const usePromocodeBatchListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  promocodeModalRef: RefObject<ModalRef>,
  agreements?: Agreement[],
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "name",
        headerName: translate("promocode_batch_admin.fields.name"),
        minWidth: 250,
        flex: 1,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "agreement",
        headerName: translate("promocode_batch_admin.fields.agreement"),
        minWidth: 250,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Link
            to={`/agreement/edit/${value}`}
            value={agreements?.find(agreement => agreement.id === value)?.name}
          />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => promocodeModalRef.current?.open(row)}
            />
            <DeleteButton
              hideText
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, promocodeModalRef, agreements],
  );
};
